import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "../../../components/admin/css/common.css";
import sweetAlert, {
  sweetStatusAlert,
  sweetConfirmAlert
} from "../../../components/common/SweetAlert.js";
import Spinner from "react-bootstrap/Spinner";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import { questionCategoryService } from "../../../service/settings/question/categoryServices.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import config from '../../../helper/config.js';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { customerConstants } from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

export default class extends Component {
  constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
      showModal: false,
      category_id: "",
      category: "",
      short_code: "",
      categories: [],
      isModified: false,
      showInsertModal: false,
      limit: 10,
      offset: 0,
      sort_column: "category_id",
      sort_direction: "ASC",
      search_term: "",
      totalCategories: 10,
      isTableDataLoading: true,
      currentPage: 0,
      editVisibility: true,
      addVisibility: true,
      deleteVisibility: true,
      isLoading: false,
    };

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllCategories, 2000);
  }

  // Reset the form fields to initail values on update, insert, edit modal close and add modal close
  resetFormFields = () => {
    this.setState({
      category: "",
      short_code: "",
    });
  };

  componentDidMount() {
    this.fetchAllCategories();
  }

  // Creating validator instance without any custom rules
  createValidationsInstance() {
    this.validator = new SimpleReactValidator();
  }

  //fetching available categories count for pagination using specific search_term
  fetchAllCategories = async () => {
    const { limit, offset, sort_column, sort_direction, search_term } = this.state;
    await questionCategoryService.getAllQuestionCategories(limit, offset, sort_column, sort_direction, search_term)
      .then((response) => {
        if (response.success) {
          this.setState({
            categories: response.data.categories,
            totalCategories: parseInt(response.data.total_count),
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching categories. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        // Handle any error that occurred during the API call
        sweetStatusAlert(
          "Failed!",
          "Error fetching categories. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false }); // Set isTableDataLoading to false after data is fetched
      });
  };

  // Handle the data fetching as per the offset(page no) changes
  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllCategories();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.fetchAllCategories();
      }
    );
  };

  // handle the data fetching as per the data per page limit gets changess
  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllCategories();
      }
    );
  };

  handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
      currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
      {
        sort_column,
        sort_direction: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
        this.fetchAllCategories();
      }
    );
  };

  // handle search text as per the regex validation and search_term , and fetch data as per the debounce
  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  // Toggle out the state of add form modal
  toggleAddCategoryModal = () => {
    this.setState((prevState) => ({
      showInsertModal: !prevState.showInsertModal,
    }));
  };

  // Toggle out the state of update form modal
  toggleUpdateCategoryModal = (category_id, category, short_code) => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      category_id: category_id,
      category: category,
      short_code: short_code,
    }));
  };

  // Sets the value of a specific state based on the value provided to the respective element based on its assigned name
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
  };

  // Pop up a sweet alert on edit or add modal and change its toggle state based on the input given to that sweet alert
  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
      });
    } else {
      this.validator.hideMessages();
      this.validator.purgeFields();
      this.resetFormFields();
      toggleFunction();
    }
  };

  // Make post request based on the fields validity and create the categories based on the state
  handleSubmit = async (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      const { category, short_code } = this.state;
      const newCategory = { name: category, short_code: short_code };

      await questionCategoryService.createCategory(newCategory)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            this.setState({ showInsertModal: false });
            sweetStatusAlert("Success!", response.message.success, "success");
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchAllCategories();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch(() => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed !", "Unable to create new category", "error");
        });
    }
  };

  // Make put request based on the fields validity and updation of necessary states
  handleUpdateSubmit = async (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      const categoryItem = {
        name: this.state.category,
        short_code: this.state.short_code,
      };

      const categoryId = this.state.category_id;
      await questionCategoryService.update(categoryItem, categoryId)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            this.setState({ showModal: false });
            sweetStatusAlert(
              "Success!",
              "Category information updated successfully..!",
              "success"
            );
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchAllCategories();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert(
            "Failed !",
            "Unable to update the category information",
            "error"
          );
        });
    }
  };

  handleDeleteCategory = (obj) => {
    sweetConfirmAlert().then(() => {
      this.setState({ isLoading: true });
      questionCategoryService.deleteCategory(obj)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            sweetStatusAlert("Success!", response.message.success, "success");
            this.fetchAllCategories();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Oops!", "Error while deleting the category", "info");
        });
    });
  };

  //Rendering the necessary components based on the logic
  render() {
    const {
      limit,
      categories,
      totalCategories,
      isTableDataLoading,
      currentPage,
      editVisibility,
      addVisibility,
      deleteVisibility,
      isLoading,
    } = this.state;
    this.validator.purgeFields();
    return (
      <>
        <ContentWrapper>
          <div className="settingsParent">
            <div className="row justify-content-between align-items-center py-5 mb-3">
              <div className="col-md-6 col-6">
                <h3 className="text-nowrap">Manage Question Categories</h3>
              </div>
              <div>
                {addVisibility && (
                  <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={() => this.toggleAddCategoryModal(true)}
                  >
                    Add Category
                  </Button>
                )}
              </div>
            </div>
            <div>
              <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
                <Form.Control
                  type="text"
                  placeholder="Search"
                  onChange={this.handleSearch}
                  isInvalid={this.state.searchError}
                  // style={{ width: "18%" }}
                  className="col-md-3 col-12"
                />
                {this.state.searchError && (
                  <Form.Control.Feedback type="invalid">
                    Invalid input
                  </Form.Control.Feedback>
                )}
              </Form.Group>
              {isLoading && (
                <PageSpinner id="show" text="Loading, Please wait!" />
              )}
              {isTableDataLoading ? (
                <div
                  className="loading-container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "75vw",
                    height: "90vh",
                  }}
                >
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </div>
              ) : categories.length > 0 ? (
                <div style={{ width: "80vw", height: "90vh", overflow: "auto" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className="thead"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handleSortChange("category_id")}
                        >
                          No{" "}
                          {this.state.sort_column === "category_id" && (
                            <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                          )}
                        </TableCell>
                        <TableCell
                          className="thead"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handleSortChange("category")}
                        >
                          Name{" "}
                          {this.state.sort_column === "category" && (
                            <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                          )}
                        </TableCell>
                        <TableCell
                          className="thead"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handleSortChange("short_code")}
                        >
                          Short Code{" "}
                          {this.state.sort_column === "short_code" && (
                            <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                          )}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                          <TableCell className="thead">Actions</TableCell>
                        )}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {categories.map((categoryItem) => (
                        <TableRow key={categoryItem.category_id}>
                          <TableCell className="tData">
                            {categoryItem.category_id}
                          </TableCell>
                          <TableCell className="tData">
                            {categoryItem.name}
                          </TableCell>
                          <TableCell className="tData">
                            {categoryItem.short_code === null ? 'N/A' : categoryItem.short_code}
                          </TableCell>
                          {(editVisibility || deleteVisibility) && (
                            <TableCell>
                              <div className="btn-group">
                                {editVisibility && (
                                  <Button
                                    onClick={() =>
                                      this.toggleUpdateCategoryModal(
                                        categoryItem.category_id,
                                        categoryItem.name,
                                        categoryItem.short_code
                                      )
                                    }
                                    className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                    title="Edit Details"
                                  />
                                )}
                                {deleteVisibility && (
                                  <Button
                                    onClick={() =>
                                      this.handleDeleteCategory(categoryItem)
                                    }
                                    className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                    title="Delete"
                                  />
                                )}
                              </div>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <MaterialCustomTablePagination
                    totalCount={totalCategories}
                    currentPage={currentPage}
                    limit={limit}
                    handlePageChange={this.handlePageChange}
                    handleRowsPerPageChange={this.handleRowsPerPageChange}
                    handlePageOffsetChange={this.handlePageOffsetChange}
                    offset={this.state.offset}
                    rowsPerPageOptions={[5, 10, 20]}
                  />
                </div>
              ) : (
                <div
                  className="text-center mb-5 mt-10"
                  style={{ height: "90vh" }}
                >
                  <label>No categories Available!</label>
                </div>
              )}
            </div>
          </div>
        </ContentWrapper>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showInsertModal}
          onHide={() =>
            this.handleSweetAlert(this.toggleAddCategoryModal, "showInsertModal")
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Create New Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Name*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter the category name..."
                    name="category"
                    value={this.state.category}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "category",
                    this.state.category,
                    "required|max:30",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The category field is required.",
                        max: "The category should not be greater than 30 characters.",
                      },
                    }
                  )}
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Short Code*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="short_code"
                    name="short_code"
                    value={this.state.short_code}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "short_code",
                    this.state.short_code,
                    "required|max:10",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The short code field is required.",
                        max: "The short code should not be greater than 10 characters.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleSubmit}
            >
              Save changes
            </Button>
            <Button
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() =>
                this.handleSweetAlert(
                  this.toggleAddCategoryModal,
                  "showInsertModal"
                )
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showModal}
          onHide={() =>
            this.handleSweetAlert(this.toggleUpdateCategoryModal, "showModal")
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Category Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Name*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter the category name..."
                    name="category"
                    value={this.state.category}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "category",
                    this.state.category,
                    "required|max:30",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The category field is required.",
                        max: "The category should not be greater than 30 characters.",
                      },
                    }
                  )}
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Short Code*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="short_code"
                    name="short_code"
                    value={this.state.short_code}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "short_code",
                    this.state.short_code,
                    "required|max:10",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The short code field is required.",
                        max: "The short code should not be greater than 10 characters.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="modal-btn"
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleUpdateSubmit}
            >
              Save changes
            </Button>
            <Button
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() =>
                this.handleSweetAlert(this.toggleUpdateCategoryModal, "showModal")
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
